import { _ as __rest } from '../../../tslib.es6-C8rd5pYo.mjs';
import { jsx } from 'react/jsx-runtime';
import { useRef, useState, useLayoutEffect, useEffect } from 'react';
import { Tabs } from './Tabs.es.js';
import { debounce } from '../../../utils/debounce.es.js';

const AutoTabs = (_a) => {
  var { items: itemsProp, selectedItemHref, shouldRenderTrack = true, onChooseItem = () => {
  } } = _a, tabProps = __rest(_a, ["items", "selectedItemHref", "shouldRenderTrack", "onChooseItem"]);
  const navRef = useRef(null);
  const [items, setItems] = useState(itemsProp);
  useLayoutEffect(() => {
    const nav = navRef.current;
    const isOverflowing = !!nav && nav.scrollWidth > nav.offsetWidth;
    if (isOverflowing) {
      const hasExtraItems = items.some((item) => item.isExtra);
      const indexOfFirstExtraItem = hasExtraItems ? items.findIndex((item) => item.isExtra) : items.length;
      setItems(items.map((item, i) => {
        return i < indexOfFirstExtraItem - 1 ? item : Object.assign(Object.assign({}, item), { isExtra: true });
      }));
    }
  }, [items]);
  useLayoutEffect(() => {
    const onResize = debounce(() => {
      setItems([...itemsProp]);
    }, 100);
    window.addEventListener("resize", onResize, { capture: true });
    return () => {
      window.removeEventListener("resize", onResize, { capture: true });
    };
  });
  useEffect(() => setItems([...itemsProp]), [itemsProp]);
  return jsx(Tabs, Object.assign({}, tabProps, { ref: navRef, items, selectedItemHref, onChooseItem, shouldRenderTrack }));
};

export { AutoTabs };
//# sourceMappingURL=AutoTabs.es.js.map
